import type { GetUsageReportV2ResponsePayload } from '@vy/api-definition';
import { GetUsageReportV2ResponseSchema } from '@vy/api-definition';
import type { Period } from '@vy/types';
import { useCallback } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

async function usageReportV2Query(period: Partial<Period>) {
  const api = getPrivateApi();
  const usageReportV2 = await api.getUsageReportV2({
    startTime: period.startTime,
    endTime: period.endTime,
  });

  return GetUsageReportV2ResponseSchema.parse(usageReportV2);
}

export function useUsageReportV2Report(
  period: Partial<Period> = {},
  options?: CustomUseQueryOptions<GetUsageReportV2ResponsePayload>,
) {
  return useQuery(queryKeys.usageReportV2Report(period), () => usageReportV2Query(period), {
    suspense: false,
    keepPreviousData: true,
    ...options,
  });
}

export function useRefreshUsageReportV2Report(period: Partial<Period> = {}) {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    const data = await usageReportV2Query(period);
    queryClient.setQueryData(queryKeys.usageReportV2Report(period), data);
  }, [queryClient, period]);
}
